import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { ClaimTypeDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-claimtype-container',
  templateUrl: './claimtype-container.component.html',
  styleUrls: ['./claimtype-container.component.scss']
})
export class ClaimTypeContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  claimtypes$: Observable<ClaimTypeDto[]>;
  loading: boolean;
  isLoadingClaimType$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingClaimType$ = this.gatwayFacade.isLoadingGateway("ClaimType");
    this.claimtypes$ = this.gatwayFacade.loadGateway("ClaimType");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteClaimType(deletedValue: any) {
    this.gatwayFacade.remove("ClaimType", deletedValue);
  }


// this method control both the create and update

  onSubmitClaimType(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.ClaimTypes;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllClaimType = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllClaimType.push(pullData[i]);
    }
  }

// check if the addAllClaimType array is not empty, then dispatch the data to the store
   if(addAllClaimType.length > 0) {
    this.gatwayFacade.add('ClaimType', addAllClaimType);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('ClaimType', allUpdates, ['id']);
  }

   }


}
